// Module
var code = "<h1 id=tabs-标签页>Tabs 标签页</h1> <p>分隔内容上有关联但属于不同类别的数据集合。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...</li> </ul> ";
// Exports
module.exports = code;